<div id="contactinfoJuncture" class="container">
  <div class="row">
    @if (!this.FlagService.flagServiceObject[6]['payfrequencyJunctureFlag']) {
      <div class="col-12">
        <div class="title">
          <fa-icon class="faHouseUser" [icon]="faHouseUser"></fa-icon>
          <h3>{{ 'junctures.contactInfo.title' | translate }}</h3>
        </div>
      </div>
    }

    @if (!this.FlagService.flagServiceObject[6]['payfrequencyJunctureFlag']) {
      <div class="input-group">
        <form id="contactInfoForm" [formGroup]="contactInfoForm">
          <div class="col-12">
            <div class="row">
              <div class="col">
                <label class="form-label" for="postCode">{{ 'junctures.contactInfo.data.postCode' | translate }}</label>
                <input id="postCode" type="text" class="form-control" name="postCode" maxlength="4" placeholder="0000" formControlName="_postCodeInput" (ngModelChange)="postCodeInputChange()" [ngClass]="{'required': !_postCodeIsValid && (this.contactInfoForm.value['_postCodeInput']?.length >= 4)}" required [attr.disabled]="_postCodeDisabled? true : null"/>
                @if (validationStarted) {
                  <div>
                    @if (!_postCodeIsValid) {
                      <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.postCodeMissing' | translate }}</div>
                    }
                  </div>
                }
                @if (this.contactInfoForm.value['_postCodeInput']?.length > 0) {
                  <div>
                    @if (!errorMessage && _postCodeIsValid && this.contactInfoForm.value['_postCodeInput']?.length >= 4) {
                      <div class="feedback valid-feedback">{{ 'junctures.contactInfo.data.ok' | translate }}</div>
                    }
                    @if (errorMessage) {
                      <div class="feedback invalid-feedback">{{ errorMessage }}</div>
                    }
                    @if (!errorMessage && !_postCodeIsValid && this.contactInfoForm.value['_postCodeInput']?.length > 0 && this.contactInfoForm.value['_postCodeInput']?.length < 4) {
                      <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.postCodeInvalid' | translate }}</div>
                    }
                  </div>
                }
              </div>
              <div class="col">
                <label class="form-label" for="settlement">{{ 'junctures.contactInfo.data.city' | translate }}</label>
                <input #settlement="ngbTypeahead" type="text" class="form-control" name="settlement" placeholder="{{ 'junctures.contactInfo.data.city' | translate }}" (focus)="focusSettlement$.next($any($event).target.value)" (click)="clickSettlement$.next($any($event).target.value)" [ngbTypeahead]="searchSettlement" formControlName="_settlementInput" (ngModelChange)="settlementInputChange()" [ngClass]="{'required': (validationStarted && !(this.contactInfoForm.value['_settlementInput']?.length > 0))}" required>
                @if (validationStarted) {
                  <div>
                    @if (!errorCity && this.contactInfoForm.value['_settlementInput']?.length > 0) {
                      <div class="feedback valid-feedback">{{ 'junctures.contactInfo.data.ok' | translate }}</div>
                    }
                    @if (!(this.contactInfoForm.value['_settlementInput']?.length > 0)) {
                      <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.cityMissing' | translate }}</div>
                    }
                  </div>
                }
                @if (contactInfoForm.value['_settlementInput']?.length > 0 && errorCity) {
                  <div class="feedback invalid-feedback">{{ errorCity }}</div>
                }
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="form-label" for="streetName">{{ 'junctures.contactInfo.data.street' | translate }}</label>
                <input #street="ngbTypeahead" type="text" class="form-control" name="streetName" placeholder="{{ 'junctures.contactInfo.data.street' | translate }}" (focus)="focusStreet$.next($any($event).target.value)" (click)="clickStreet$.next($any($event).target.value)" [ngbTypeahead]="searchStreet" formControlName="_streetNameInput" (ngModelChange)="streetInputChange()" [ngClass]="{'required': (validationStarted && !(this.contactInfoForm.value['_streetNameInput']?.length > 0))}" required>
                @if (validationStarted) {
                  <div>
                    @if (this.contactInfoForm.value['_streetNameInput']?.length > 0) {
                      <div class="feedback valid-feedback">{{ 'junctures.contactInfo.data.ok' | translate }}</div>
                    }
                    @if (!(this.contactInfoForm.value['_streetNameInput']?.length > 0)) {
                      <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.streetMissing' | translate }}</div>
                    }
                  </div>
                }
              </div>
              <div class="col">
                <label class="form-label" for="houseNumber">{{ 'junctures.contactInfo.data.houseNumber' | translate }}</label>
                <input id="houseNumber" class="form-control" type="text" name="house-number" placeholder="{{ 'junctures.contactInfo.data.houseNumber' | translate }}" formControlName="_houseNumberInput" (ngModelChange)="houseNumberInputChange()" [ngClass]="{'required': (validationStarted && !(this.contactInfoForm.value['_houseNumberInput']?.length > 0))}" required>
                @if (validationStarted) {
                  <div>
                    @if (this.contactInfoForm.value['_houseNumberInput']?.length > 0) {
                      <div class="feedback valid-feedback">{{ 'junctures.contactInfo.data.ok' | translate }}</div>
                    }
                    @if (!(this.contactInfoForm.value['_houseNumberInput']?.length > 0)) {
                      <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.houseNumberMissing' | translate }}</div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="form-check">
              <input id="sameAsAddress" class="form-check-input" type="checkbox" (change)="sameAsAddress()" formControlName="_sameAsAddressInput">
              <label class="form-check-label" for="sameAsAddress">{{ 'junctures.contactInfo.data.sameAddress' | translate }}</label>
            </div>
            <div class="card">
              <h4 class="text-center">{{ 'junctures.contactInfo.data.postalAddress' | translate }}</h4>
              <div class="row">
                <div class="col">
                  <label class="form-label" for="postalPostCode">{{ 'junctures.contactInfo.data.postCode' | translate }}</label>
                  <input id="postalPostCode" type="text" class="form-control" name="postalPostCode" maxlength="4" placeholder="0000" formControlName="_postalPostCodeInput" (ngModelChange)="postalPostCodeInputChange()" [ngClass]="{'required': !_postalPostCodeIsValid && (this.contactInfoForm.value['_postalPostCodeInput']?.length >= 4)}" required [attr.disabled]="_postalPostCodeDisabled? true : null"/>
                  @if (validationStarted) {
                    <div>
                      @if (!_postalPostCodeIsValid) {
                        <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.postCodeMissing' | translate }}</div>
                      }
                    </div>
                  }
                  @if (this.contactInfoForm.value['_postalPostCodeInput']?.length > 0) {
                    <div>
                      @if (!postalMessage && _postalPostCodeIsValid && this.contactInfoForm.value['_postalPostCodeInput']?.length >= 4) {
                        <div class="feedback valid-feedback">{{ 'junctures.contactInfo.data.ok' | translate }}</div>
                      }
                      @if (postalMessage) {
                        <div class="feedback invalid-feedback">{{ postalMessage }}</div>
                      }
                      @if (!postalMessage && !_postalPostCodeIsValid && this.contactInfoForm.value['_postalPostCodeInput']?.length > 0) {
                        <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.postCodeInvalid' | translate }}</div>
                      }
                    </div>
                  }
                </div>
                <div class="col">
                  <label class="form-label" for="postalSettlement">{{ 'junctures.contactInfo.data.city' | translate }}</label>
                  <input #settlement="ngbTypeahead" type="text" class="form-control" name="postalSettlement" placeholder="Település" (focus)="focusPostalSettlement$.next($any($event).target.value)" (click)="clickPostalSettlement$.next($any($event).target.value)" [ngbTypeahead]="searchPostalSettlement" formControlName="_postalSettlementInput" (ngModelChange)="postalSettlementInputChange()" [ngClass]="{'required': (validationStarted && !(this.contactInfoForm.value['_postalSettlementInput']?.length > 0))}" required>
                  @if (validationStarted) {
                    <div>
                      @if (!errorPostalCity && this.contactInfoForm.value['_postalSettlementInput']?.length > 0) {
                        <div class="feedback valid-feedback">{{ 'junctures.contactInfo.data.ok' | translate }}</div>
                      }
                      @if (!(this.contactInfoForm.value['_postalSettlementInput']?.length > 0)) {
                        <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.cityMissing' | translate }}</div>
                      }
                    </div>
                  }
                  @if (contactInfoForm.value['_postalSettlementInput']?.length > 0 && errorPostalCity) {
                    <div class="feedback invalid-feedback">{{ errorPostalCity }}</div>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label class="form-label" for="postalStreetName">{{ 'junctures.contactInfo.data.street' | translate }}</label>
                  <input #street="ngbTypeahead" type="text" class="form-control" name="postalStreetName" placeholder="{{ 'junctures.contactInfo.data.street' | translate }}" (focus)="focusPostalStreet$.next($any($event).target.value)" (click)="clickPostalStreet$.next($any($event).target.value)" [ngbTypeahead]="searchPostalStreet" formControlName="_postalStreetNameInput" (ngModelChange)="postalStreetInputChange()" [ngClass]="{'required': (validationStarted && !(this.contactInfoForm.value['_postalStreetNameInput']?.length > 0))}" required>
                  @if (validationStarted) {
                    <div>
                      @if (this.contactInfoForm.value['_postalStreetNameInput']?.length > 0) {
                        <div class="feedback valid-feedback">{{ 'junctures.contactInfo.data.ok' | translate }}</div>
                      }
                      @if (!(this.contactInfoForm.value['_postalStreetNameInput']?.length > 0)) {
                        <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.streetMissing' | translate }}</div>
                      }
                    </div>
                  }
                </div>
                <div class="col">
                  <label class="form-label" for="postalHouseNumber">{{ 'junctures.contactInfo.data.houseNumber' | translate }}</label>
                  <input id="postalHouseNumber" class="form-control" type="text" name="postal-house-number" placeholder="{{ 'junctures.contactInfo.data.houseNumber' | translate }}" formControlName="_postalHouseNumberInput" [ngClass]="{'required': (validationStarted && !(this.contactInfoForm.value['_postalHouseNumberInput']?.length > 0))}" required>
                  @if (validationStarted) {
                    <div>
                      @if (this.contactInfoForm.value['_postalHouseNumberInput']?.length > 0) {
                        <div class="feedback valid-feedback">{{ 'junctures.contactInfo.data.ok' | translate }}</div>
                      }
                      @if (!(this.contactInfoForm.value['_postalHouseNumberInput']?.length > 0)) {
                        <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.houseNumberMissing' | translate }}</div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <label class="form-label" for="mobileNumber">{{ 'junctures.contactInfo.data.mobile' | translate }}</label>
            <input id="mobileNumber" class="form-control" type="text" name="mobile-number" placeholder="{{ 'junctures.contactInfo.data.mobileFormat' | translate }}" formControlName="_mobileNumberInput" (ngModelChange)="mobileValidation($event)" [ngClass]="{'required': (!_mobileNumberInputIsValid && (this.contactInfoForm.value['_mobileNumberInput']?.length > 0) && validationStarted)}" required>
            @if (validationStarted) {
              <div>
                @if (!_mobileNumberInputIsValid) {
                  <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.mobileMissing' | translate }}</div>
                }
              </div>
            }
            <div>
              @if (_mobileNumberInputIsValid) {
                <div class="feedback valid-feedback">{{ 'junctures.contactInfo.data.ok' | translate }}</div>
              }
              @if (!_mobileNumberInputIsValid && this.contactInfoForm.value['_mobileNumberInput']?.length > 0) {
                <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.mobileInvalid' | translate }}</div>
              }
            </div>
            <label class="form-label" for="emailAddress">{{ 'junctures.contactInfo.data.email' | translate }}</label>
            <input id="emailAddress" class="form-control" type="text" name="email-address" placeholder="{{ 'junctures.contactInfo.data.email' | translate }}" formControlName="_emailAddressInput" (ngModelChange)="emailValidation($event)" [ngClass]="{'required': (!_emailAddressInputIsValid && (this.contactInfoForm.value['_emailAddressInput']?.length > 0) && validationStarted)}" required>
            @if (validationStarted) {
              <div>
                @if (!_emailAddressInputIsValid) {
                  <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.emailMissing' | translate }}</div>
                }
              </div>
            }
            <div>
              @if (_emailAddressInputIsValid) {
                <div class="feedback valid-feedback">{{ 'junctures.contactInfo.data.ok' | translate }}</div>
              }
              @if (!_emailAddressInputIsValid && this.contactInfoForm.value['_emailAddressInput']?.length > 0) {
                <div class="feedback invalid-feedback">{{ 'junctures.contactInfo.data.emailInvalid' | translate }}</div>
              }
            </div>
          </div>
          <div class="d-flex summary mt-4">
            <div class="w-100 flex">
              <fa-icon class="faHouseUser text-center me-2" [icon]="faHouseUser"></fa-icon>
              <div class="text">
                <span class="name">{{ this.contactInfoForm.value['_mobileNumberInput'] }}</span><br>
                <span class="date">{{ this.contactInfoForm.value['_emailAddressInput'] }}</span>
              </div>
            </div>
            <div class="flex-shrink-1">
              <button (click)="sendContactInfo()" type="button" class="btn btn-light float-end">{{ 'common.ok' | translate }}</button>
            </div>
          </div>
        </form>
      </div>
    }
  </div>

  @if (this.FlagService.flagServiceObject[6]['payfrequencyJunctureFlag']) {
    <div class="row feedback-module" (click)="contactinfoJunctureClick()">
      <div class="d-flex p-0">
        <a class="w-100">
          <fa-icon class="text-center ms-3 me-3" [icon]="faHouseUser"></fa-icon>
          <div class="text">
            <span class="top">{{ this.insurantData.insuredPerson.mobileNumber }}</span><br>
            <span class="bottom">{{ this.insurantData.insuredPerson.email }}</span>
          </div>
        </a>
        <div class="flex-shrink-1">
          <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
        </div>
      </div>
    </div>
  }
</div>
